import { gql } from '@apollo/client';

import { SALE_ORDER_FIELDS } from '@/modules/doctor-pos/doctor-pos.gql';

export const SALES_HISTORY_TICKETS_QUERY = gql`
  ${SALE_ORDER_FIELDS}
  query SalesHistoryTickets(
    $from: DateTime
    $to: DateTime
    $ticket_folio: String
    $search_text: String
    $offset: Int
    $limit: Int
  ) {
    salesHistoryTickets(
      from: $from
      to: $to
      ticket_folio: $ticket_folio
      search_text: $search_text
      offset: $offset
      limit: $limit
    ) {
      items {
        entry_kind
        sale_order_id
        open_account_id
        ticket_id
        ticket_payload_json
        sale_folio_number
        ticket_folio_number
        paid_at
        total_cents
        status
        payment_method_summary
        tutor_name
        pet_name
        customer_snapshot_json
        pet_snapshot_json
        payment_methods {
          payment_method_id
          payment_method_code
          payment_method_name
          amount_cents
        }
        sale_order {
          ...SaleOrderFields
        }
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const REGISTER_SALE_TICKET_REPRINT_MUTATION = gql`
  mutation RegisterSaleTicketReprint($ticket_id: ID!) {
    registerSaleTicketReprint(ticket_id: $ticket_id) {
      id
      ticket_id
      reprinted_by
      workstation_id
      created_at
    }
  }
`;
